import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Modal, Button, Row, Col, Select as AntdSelect } from "antd";
import MaterialIcon from "components/common/MaterialIcon";
import jMoment from "components/classes/Jmomen";
import moment from "moment-jalaali";
import TreeView from "components/common/TreeView";
import uuidv1 from "uuid/v1";
import { getForm } from "./Module";

import { Field, reduxForm, getFormValues, isPristine } from "redux-form";
import {
  Text,
  TextArea,
  Date,
  Time,
  CheckBoxSingel,
  Cascader,
  Select,
  Number,
  File,
  Hidden,
} from "components/redux-form";
import validate from "./validate";
import DailyReport from "./common/DailyReport/DailyReport";
import WritKey from "./common/WritKey/WritKey";
import SelectWritInfo from "./common/SelectWrit/SelectWritInfo";
import Rule from "./common/Rule/Rule";
import Recruitment from "./common/Recruitment/Recruitment";
import Position from "./common/Position/Position";
import SelectDateFoodMealInfo from "./common/SelectDateFoodMeal/SelectDateFoodMealInfo";
import SelectDateFoodMeal from "./common/SelectDateFoodMeal/SelectDateFoodMeal";
import SelectFoodMealInfo from "./common/SelectFoodMeal/SelectFoodMealInfo";
import SelectFoodMeal from "./common/SelectFoodMeal/SelectFoodMeal";
import SelectSelfService from "./common/SelectSelfService/SelectSelfService";
import SelectSelfServiceInfo from "./common/SelectSelfService/SelectSelfServiceInfo";
import SelectReserveDateFoodMealInfo from "./common/SelectReserveDateFoodMeal/SelectReserveDateFoodMealInfo";
import SelectReserveDateFoodMeal from "./common/SelectReserveDateFoodMeal/SelectReserveDateFoodMeal";
import SelectUserShiftInfo from "./common/SelectUserShift/SelectUserShiftInfo";
import SelectUserShift from "./common/SelectUserShift/SelectUserShift";
import FamiliesNameInfo from "./common/FamiliesName/FamiliesNameInfo";
import FamiliesName from "./common/FamiliesName/FamiliesName";
import Types from "routes/General/Types";
import Device from "./common/Device/Device";
import DepartmentList from "./common/DepartmentList/DepartmentList";
import DepartmentListInfo from "./common/DepartmentList/DepartmentListInfo";
import SelectProfiles from "./common/Profile/SelectProfiles";
import SelectProfileInfo from "./common/Profile/SelectProfileInfo";
import Category from "./common/Category/Category";
import GeoFence from "./common/GeoFence/GeoFence";
import { index } from "../../routes/Home/Basic/Category/Module";
import SelectShiftProfiles from "./common/Profile/SelectShiftProfiles";

@reduxForm({
  form: "FormBuilder",
  destroyOnUnmount: false,
  validate,
  onSubmit: () => {},
})
@connect(
  (state) => ({
    fields: state.FormBuilder.Main.fields,
    values: getFormValues("FormBuilder")(state),
    isPristine: isPristine("FormBuilder")(state),
    category: state.Basic.Category.categories,
  }),
  {
    getForm,
  }
)
@autobind
/**
 *
 */
export default class FormBuilder extends React.PureComponent {
  static propTypes = {
    formId: PropTypes.number,
    fields: PropTypes.any,
    formFields: PropTypes.any,
    values: PropTypes.object,
    formValues: PropTypes.object,
    formDefaultValue: PropTypes.object,
    editable: PropTypes.bool,
    visible: PropTypes.bool,
    showHidden: PropTypes.bool,
    md: PropTypes.number,
    getForm: PropTypes.func,
    componentName: PropTypes.string,
    visibility: PropTypes.string,
    rowClick: PropTypes.object,
    valueType: PropTypes.string,
  };

  static defaultProps = {
    formId: undefined,
    formFields: {},
    fields: {},
    values: {},
    formValues: {},
    formDefaultValue: {},
    editable: true,
    visible: true,
    showHidden: false,
    md: 12,
    componentName: "FormBuilder",
    visibility: "",
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
    // console.log(props);
    this.state = {
      _render: "1",
      _render_prev: "0",
      formFields: !app._.isEmpty(props.formFields)
        ? props.formFields
        : props.fields,
    };
  }

  /**
   *
   */
  componentDidMount() {
    if (this.props.formId) {
      this.props.getForm(
        this.props.formId,
        {
          includes: ["fields"],
        },
        (err, res) => {
          if (!err) {
            this.props.validate(this.props.values, {
              formFields: res.data.form,
            });
          } else {
            console.log("error", err);
          }
        }
      );
    }
  }

  /**
   *
   * @param {object} np
   */
  componentWillReceiveProps(np) {
    console.log("props.formFieldprops.formFieldss", this.props.formFields);

    if (!app._.isEqual(this.props.formId, np.formId)) {
      this.props.getForm(
        np.formId,
        {
          includes: ["fields"],
        },
        (err, res) => {
          this.setState({
            _render_prev: this.state._render,
            _render: `${Math.random()}`,
          });
          if (!err) {
            np.validate(np.values, { formFields: res.data.form });
          } else {
            console.log("error", err);
          }
        }
      );
    }
    if (!app._.isEqual(this.props.values, np.values)) {
      this.setState({ _render_prev: this.state._render });
    }
    if (!app._.isEqual(this.props.fields, np.fields)) {
      this.setState({
        formFields: np.fields,
        _render_prev: this.state._render,
        _render: `${Math.random()}`,
      });
    }
    if (!app._.isEqual(this.props.formFields, np.formFields)) {
      this.setState({
        formFields: np.formFields,
        _render_prev: this.state._render,
        _render: `${Math.random()}`,
      });
    }
  }

  /**
   *
   */
  componentWillUnmount() {
    // super.componentWillUnmount();
  }

  _renderLabel = (item) => {
    return item && item.label;
  };
  _renderValue = (item) => {
    return item.rule && item.rule.id ? item.rule.id : item.id;
  };

  /**
   *
   * @param {Object[]} groups
   * @return {Object[]}
   * @private
   */
  _renderGroups(groups) {
    let _groups = [];
    groups.map((group) => {
      if (group.moduleId !== 0) {
        let _group = {
          value: this._renderValue(group),
          label: this._renderLabel(group),
        };

        if (!app._.isEmpty(group.children)) {
          _group.children = this._renderGroups(group.children);
        }

        _groups.push(_group);
      }
    });
    return _groups;
  }
  /**
   *
   * @param {*} item
   * @param {*} index
   */
  _renderItem(item, index) {
    const {
      md,
      clockingDisabled,
      formDefaultValue,
      values,
      visible,
      visibility,
      rowClick,
      columnTitle,
      goMonthLater,
      formTitle,
      positionValue,
      getClockingType,
    } = this.props;
    const { _render, _render_prev } = this.state;

    let _item = "";

    const fromDate = moment(rowClick?.date).format("YYYY-MM-DD");
    const fromTime = moment(rowClick?.clockIn1).format("hh:mm");
    if (!visible) return _item;
    let _type = item.type.toUpperCase();
    let name = app._.camelCase(item.name);
    let defaultValue =
      values && values.values && values.values[name] !== undefined
        ? values.values[name]
        : formDefaultValue && formDefaultValue[name]
        ? formDefaultValue[name]
        : item.defaultValue;

    // console.log(defaultValue);

    if (app.lang.locale === "en") item.label = item.name;

    let _key = `${index}_${item.id}`;

    if (item.permission !== undefined && item.permission === false) {
      _item = (
        <Field
          name={`values[${name}]`}
          key={_key}
          label={app.translate(
            `components.form-builder.${item.label}`,
            `${item.label}`
          )}
          component={Hidden}
          defaultValue={item.defaultValue}
        />
      );
    } else {
      console.log("this.props.values",this.props.values);
      
      switch (_type) {
        case "STRING":
          _item = (
            <Col sm={24} md={md} key={_key}>
              {app.translate(
                `components.form-builder.${item.label}`,
                `${item.label}`
              )}
              :{" "}
              {item.defaultValue
                ? item.defaultValue
                : formDefaultValue && formDefaultValue[name]}
            </Col>
          );
          break;
        case "DATEPICKER":
        case "DATE":
          _item = (
            <Col sm={24} md={md} key={_key} style={{ display: visibility }}>
              <Field
                name={`values[${name}]`}
                // min={
                //   item.name === "base_date"
                //     ? jMoment().format("YYYY-MM-DD")
                //     : undefined
                // }
                label={app.translate(
                  `components.form-builder.${item.label}`,
                  `${item.label}`
                )}
                autoComplete="off"
                required={item.required == 1 ? true : false}
                defaultValue={rowClick ? fromDate : defaultValue}
                // props={{
                //   type: rowClick,
                // }}
                goMonthLater={goMonthLater}
                index={index}
                disabled={clockingDisabled}
                Allvalues={values}
                component={Date}
              />
            </Col>
          );
          break;
        case "TIMEPICKER":
        case "TIME":
          _item = (
            <Col sm={24} md={md} key={_key} style={{ display: visibility }}>
              <Field
                name={`values[${name}]`}
                label={app.translate(
                  `components.form-builder.${item.label}`,
                  item.label
                )}
                component={Time}
                autoComplete="off"
                defaultValue={
                  columnTitle
                    ? columnTitle
                    : defaultValue
                    ? defaultValue
                    : "00:00"
                }
                required={item.required == 1 ? true : false}
              />
            </Col>
          );
          break;
        case "NUMBER":
          _item = (
            <Col sm={24} md={md} key={_key}>
              <Field
                name={`values[${name}]`}
                label={app.translate(
                  `components.form-builder.${item.label}`,
                  item.label
                )}
                min={1}
                component={Number}
                defaultValue={
                  values && values.values && values.values[name] !== undefined
                    ? parseFloat(values.values[name])
                    : formDefaultValue && formDefaultValue[name]
                    ? parseFloat(formDefaultValue[name])
                    : undefined
                }
                required={item.required == 1 ? true : false}
              />
            </Col>
          );
          break;
        case "TEXT":
          _item = (
            <Col sm={24} md={md} key={_key}>
              <Field
                name={`values[${name}]`}
                label={app.translate(
                  `components.form-builder.${item.label}`,
                  item.label
                )}
                component={Text}
                defaultValue={defaultValue}
                required={item.required == 1 ? true : false}
              />
            </Col>
          );
          break;

        case "HIDDEN":
          break;
        case "FILE":
          _item = (
            <Col sm={24} md={md} key={_key}>
              <Field
                name={`values[${name}]`}
                label={app.translate(
                  `components.form-builder.${item.label}`,
                  item.label
                )}
                component={File}
                defaultValue={defaultValue}
                required={item.required == 1 ? true : false}
              />
            </Col>
          );
          break;
        case "SELECT":
        case "SELECT.MULTI":
          switch (item.resource) {
            case "Api\\TA\\Modules\\Device\\Models\\Device":
              _item = (
                <Col sm={24} md={md} key={_key}>
                  <Field
                    name={`values[${name}]`}
                    label={app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}
                    component={Device}
                    defaultValue={defaultValue}
                    required={item.required == 1 ? true : false}
                  />
                </Col>
              );
              break;
            case "Api\\General\\Models\\Position":
            case "/positions":
              if (_type === "SELECT.MULTI") {
                _item = (
                  <Col sm={24} md={md} key={_key}>
                    <Field
                      name={`values[${name}]`}
                      label={app.translate(
                        `components.form-builder.${item.label}`,
                        item.label
                      )}
                      component={Position}
                      defaultValue={defaultValue}
                      componentName={this.props.componentName}
                      positionValue={positionValue}
                      getSelected={this.props.getSelected}
                      errorDescription={this.props.errorDescription}
                    />
                  </Col>
                );
              } else {
                _item = (
                  <Col sm={24} md={md} key={_key}>
                    <Field
                      name={`values[${name}]`}
                      label={app.translate(
                        `components.form-builder.${item.label}`,
                        item.label
                      )}
                      component={DepartmentList}
                      defaultValue={defaultValue}
                      required={item.required == 1 ? true : false}
                    />
                  </Col>
                );
              }
              break;
            case "Api\\General\\Models\\Group":
              {
                app.haveUiPermission([
                  "6d078aea6d078aea46d1b919e505bbf66d5265efbcf0be35d92c95c0149f8042899bba1f46d1b919e505bbf66d5265efbcf0be35d92c95c0149f8042899bba1f",
                ])
                  ? (_item = (
                      <Col sm={24} md={md} key={_key}>
                        <Field
                          name={`values[${name}]`}
                          label={"گروه‌ها"}
                          component={Category}
                          defaultValue={defaultValue ? defaultValue : []}
                          required={item.required == 1 ? true : false}
                        />
                      </Col>
                    ))
                  : null;
              }
              break;
            case "Api\\General\\Models\\GeoFence":
              {
                app.haveUiPermission([
                  "6d078aea6d078aea46d1b919e505bbf66d5265efbcf0be35d92c95c0149f8042899bba1f46d1b919e505bbf66d5265efbcf0be35d92c95c0149f8042899bba1f",
                ])
                  ? (_item = (
                      <Col sm={24} md={md} key={_key}>
                        <Field
                          name={`values[${name}]`}
                          label={"کارگاه‌ها"}
                          component={GeoFence}
                          defaultValue={defaultValue ? defaultValue : []}
                          required={item.required == 1 ? true : false}
                        />
                      </Col>
                    ))
                  : null;
              }
              break;
            case "Api\\FeedingConsole\\Models\\DateFoodMeal":
              _item = (
                <Col sm={24} key={_key}>
                  <Field
                    name={`values[${name}]`}
                    label={app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}
                    component={SelectDateFoodMeal}
                    values={values && values.values ? values.values : undefined}
                    defaultValue={defaultValue}
                    required={item.required == 1 ? true : false}
                    positionId={this.props.values.positionId}
                  />
                </Col>
              );
              break;
            case "Api\\FeedingConsole\\Models\\Meal":
              _item = (
                <Col sm={24} key={_key}>
                  <Field
                    name={`values[${name}]`}
                    label={app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}
                    component={SelectFoodMeal}
                    values={values && values.values ? values.values : undefined}
                    defaultValue={defaultValue}
                    required={item.required == 1 ? true : false}
                    positionId={this.props.values.positionId}
                  />
                </Col>
              );
              break;
            case "Api\\FeedingConsole\\Models\\SelfModel":
              _item = (
                <Col sm={24} key={_key}>
                  <Field
                    name={`values[${name}]`}
                    label={app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}
                    component={SelectSelfService}
                    values={values && values.values ? values.values : undefined}
                    defaultValue={defaultValue}
                    required={item.required == 1 ? true : false}
                    positionId={this.props.values.positionId}
                  />
                </Col>
              );
              break;
            case "Api\\FeedingConsole\\Models\\Reserve":
              _item = (
                <Col sm={24} key={_key}>
                  <Field
                    name={`values[${name}]`}
                    label={app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}
                    component={SelectReserveDateFoodMeal}
                    values={values && values.values ? values.values : undefined}
                    defaultValue={defaultValue}
                    required={item.required == 1 ? true : false}
                    positionId={this.props.values.positionId}
                  />
                </Col>
              );
              break;
            case "Api\\TA\\Models\\Writ":
              _item = (
                <Col sm={24} key={_key}>
                  <Field
                    name={`values[${name}]`}
                    label={app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}
                    component={WritKey}
                    defaultValue={defaultValue}
                    required={item.required == 1 ? true : false}
                    positionId={this.props.values.positionId}
                  />
                </Col>
              );
              break;
            case "Api\\General\\Models\\Type":
              let types = this._renderGroups(Types.items(this.props.form));
              _item = (
                <Col sm={24} key={_key}>
                  <Field
                    name={`values[${name}]`}
                    label={app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}
                    component={Cascader}
                    items={types}
                    defaultValue={defaultValue}
                    required={item.required == 1 ? true : false}
                  />
                </Col>
              );
              break;
            case "Api\\Users\\Models\\Profile":              
              _item = (
                <Col sm={24} key={_key}>
                  <Field
                    name={`values[${name}]`}
                    label={app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}
                    component={SelectProfiles}
                    positionId={this.props.values.positionId}
                    defaultValue={defaultValue}
                    required={item.required == 1 ? true : false}
                    showSearch={true}
                  />
                </Col>
              );
              break;
            case "Api\\Users\\Models\\ShiftProfile":              
              _item = (
                <Col sm={24} key={_key}>
                  <Field
                    name={`values[${name}]`}
                    label={app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}
                    component={SelectShiftProfiles}
                    positionId={"1"}
                    defaultValue={defaultValue}
                    required={item.required == 1 ? true : false}
                    showSearch={true}
                  />
                </Col>
              );
              break;
            case "Api\\Requests\\Models\\Request":
              _item = (
                <Col sm={24} key={_key}>
                  <Field
                    name={`values[${name}]`}
                    label={app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}
                    component={Select}
                    // showSearch
                    // filterOption={(input, option) => 
                    //   option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                    // }
                    defaultValue={defaultValue}
                    required={item.required == 1 ? true : false}
                  />
                </Col>
              );
              break;
            case "Api\\General\\Models\\Shift":
              _item = (
                <Col sm={24} key={_key}>
                  <Field
                    name={`values[${name}]`}
                    label={app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}
                    component={SelectUserShift}
                    values={values}
                    defaultValue={defaultValue}
                    required={item.required == 1 ? true : false}
                    positionId={
                      item.name === "colleague_shift"
                        ? "0"
                        : this.props.values.positionId
                    }
                    dateKey={
                      item.name === "colleague_shift"
                        ? "colleague_shift_date"
                        : "my_shift_date"
                    }
                    getMethod={
                      item.name === "colleague_shift"
                        ? "personnelKey"
                        : "positionKey"
                    }
                  />
                </Col>
              );
              break;

            default:
              if (item.name === "clocking_type") {
                _item = (
                  <Col sm={24} md={md} key={_key}>
                    <Field
                      name={`values[${name}]`}
                      label={app.translate(
                        `components.form-builder.${item.label}`,
                        item.label
                      )}
                      component={Select}
                      defaultValue={
                        getClockingType ? getClockingType : "indeterminate"
                      }
                      required={item.required == 1 ? true : false}
                    >
                      <AntdSelect.Option value="in">
                        <span>
                          {app.translate("components.form-builder.clock_in")}
                        </span>
                        <MaterialIcon
                          name="arrow-down-thick"
                          size="tiny"
                          style={{
                            color: "green",
                          }}
                        />
                      </AntdSelect.Option>
                      <AntdSelect.Option value="out">
                        <span>
                          {app.translate("components.form-builder.clock_out")}
                        </span>
                        <MaterialIcon
                          name="arrow-up-thick"
                          size="tiny"
                          style={{
                            color: "red",
                          }}
                        />
                      </AntdSelect.Option>
                      <AntdSelect.Option value="indeterminate">
                        <span>
                          {app.translate("components.form-builder.attendance")}
                        </span>
                        <MaterialIcon
                          name="swap-vertical"
                          size="tiny"
                          style={{
                            color: "orange",
                          }}
                        />
                      </AntdSelect.Option>
                    </Field>
                  </Col>
                );
              } else {
                let options = [];
                let _values = {};
                let multiple = {};

                if (item.values && item.values !== "") {
                  if (typeof item.values === "object") {
                    _values = item.values ? item.values : {};
                  } else {
                    console.log("ititemem",item);
                    
                    _values = item?.values ? JSON.parse(item?.values) : {};
                  }
                } else {
                  if (item.props && item.props !== "") {
                    if (typeof item.props === "object") {
                      _values = item.props ? item.props : {};
                    } else {
                      _values = item.props ? JSON.parse(item.props) : {};
                    }
                  }
                }
                let keys = Object.keys(_values);
                if (keys.length > 0) {
                  app._.map(keys, (key) => {
                    options.push(
                      <AntdSelect.Option key={key} value={key}>
                        {_values[key]}
                      </AntdSelect.Option>
                    );
                  });
                }
                if (_type === "SELECT.MULTI") {
                  multiple = { mode: "multiple" };
                }
                _item = (
                  <Col sm={24} md={md} key={_key}>
                    <Field
                      name={`values[${name}]`}
                      label={app.translate(
                        `components.form-builder.${item.label}`,
                        item.label
                      )}
                      component={Select}
                      defaultValue={
                        values &&
                        values.values &&
                        values.values[name] !== undefined &&
                        keys.indexOf(values.values[name]) > -1
                          ? values.values[name]
                          : item && item.defaultValue
                          ? item.defaultValue
                          : formDefaultValue && formDefaultValue[name]
                      }
                      {...multiple}
                      required={item.required == 1 ? true : false}
                    >
                      {options}
                    </Field>
                  </Col>
                );
              }
          }
          break;
        case "SELECT.TREE":
          if (item.resource === "Api\\General\\Models\\Type") {
            _item = (
              <Col sm={24} md={md} key={_key}>
                <Field
                  key={_key}
                  name={`values[${name}]`}
                  label={app.translate(
                    `components.form-builder.${item.label}`,
                    item.label
                  )}
                  component={Rule}
                  defaultValue={
                    _render === _render_prev ? defaultValue : item.defaultValue
                  }
                  required={item.required == 1 ? true : false}
                  feildValues={item.values}
                  feildOtherValues={
                    item.props && typeof item.props === "object"
                      ? item.props
                      : {}
                  }
                />
              </Col>
            );
          }
          if (item.resource === "Api\\General\\Models\\RecruitmentType") {
            _item = (
              <Col sm={24} md={md} key={_key}>
                <Field
                  name={`values[${name}]`}
                  label={app.translate(
                    `components.form-builder.${item.label}`,
                    item.label
                  )}
                  component={Recruitment}
                  defaultValue={defaultValue}
                  required={item.required == 1 ? true : false}
                />
              </Col>
            );
          }
          if (item.resource === "Api\\Hr\\Models\\RecruitmentType") {
            _item = (
              <Col sm={24} md={md} key={_key}>
                <Field
                  name={`values[${name}]`}
                  label={app.translate(
                    `components.form-builder.${item.label}`,
                    item.label
                  )}
                  component={Recruitment}
                  defaultValue={defaultValue}
                  required={item.required == 1 ? true : false}
                />
              </Col>
            );
          }

          if (item.resource === "Api\\Hr\\Models\\Type") {
            _item = (
              <Col sm={24} md={md} key={_key}>
                <Field
                  key={_key}
                  name={`values[${name}]`}
                  label={app.translate(
                    `components.form-builder.${item.label}`,
                    item.label
                  )}
                  component={Rule}
                  defaultValue={
                    _render === _render_prev ? defaultValue : item.defaultValue
                  }
                  required={item.required == 1 ? true : false}
                  feildValues={item.values}
                  feildOtherValues={
                    item.props && typeof item.props === "object"
                      ? item.props
                      : {}
                  }
                />
              </Col>
            );

            // if (item.resource === "Api\\Hr\\Models\\Type") {
            //   _item = (
            //     <Col sm={24} md={md} key={_key}>
            //       <Field
            //         name={`values[${name}]`}
            //         label={"گروهها"}
            //         component={Category}
            //         defaultValue={defaultValue}
            //         required={item.required == 1 ? true : false}
            //       />
            //     </Col>

            //   );
            // _item = (
            //   <div>
            //     <Row sm={24}>
            //       <TreeView
            //         checkable
            //         title={undefined}
            //         showSearch={false}
            //         // onCheck={this._onCheckTree}
            //         treeData={this.props.category}
            //         // defaultCheckedKeys={
            //         //   _meals
            //         //     ? _meals
            //         //     : meals && meals[0]
            //         //     ? meals[0].id
            //         //       ? meals.pluck("id", (item) => item.toString())
            //         //       : []
            //         //     : []
            //         // }
            //         checkAllButton={true}
            //         treeStyle={{ height: "calc(100% - 40px)" }}
            //         // ref={(input) => (this.treeView = input)}
            //         visible={true}
            //       />
            //     </Row>
            //   </div>
            // );
          }
          break;
        case "CHECKBOX":
          _item = (
            <Col sm={24} md={md} key={_key}>
              <Field
                name={`values[${name}]`}
                label={app.translate(
                  `components.form-builder.${item.label}`,
                  item.label
                )}
                component={CheckBoxSingel}
                defaultValue={defaultValue}
                required={item.required == 1 ? true : false}
                inline={true}
              />
            </Col>
          );
          break;
        case "JSON":
          _item = (
            <Col sm={24} key={_key}>
              <Field
                name={`values[${name}]`}
                label={app.translate(
                  `components.form-builder.${item.label}`,
                  item.label
                )}
                component={DailyReport}
                defaultValue={defaultValue}
                required={item.required == 1 ? true : false}
                dateFromBack={values.values && values.values.dateToBack}
                dateToGoing={values.values && values.values.dateFromGoing}
                inline={true}
              />
            </Col>
          );
          break;
        default: {
          let _name = item.name;
          switch (_name) {
            case "userFamiliesName":
              _item = (
                <Col sm={24} md={24} key={_key}>
                  <Field
                    name={`values[${name}]`}
                    label={app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}
                    component={FamiliesName}
                    defaultValue={defaultValue}
                    positionId={this.props.values.positionId}
                  />
                </Col>
              );
              break;
            default:
              _item = (
                <Col sm={24} key={_key}>
                  <span>
                    {item.name} : {item.type}
                  </span>
                </Col>
              );
          }
        }
      }
    }
    return _item;
  }

  _valueTypeItem(valueType) {
    const {
      md,
      formDefaultValue,
      values,
      visible,
      visibility,
      rowClick,
      columnTitle,
    } = this.props;
    let _type = valueType.toUpperCase();
    // let defaultValue =
    // values && values.values && values.values[name] !== undefined
    //   ? values.values[name]
    //   : formDefaultValue && formDefaultValue[name]
    //   ? formDefaultValue[name]
    //   : item.defaultValue;
    let _item = "";
    switch (_type) {
      case "STRING":
        _item = (
          <Col sm={24} md={24}>
            <Field
              name={`valueType`}
              label={app.translate(
                `components.form-builder.متن دلخواه`,
                "متن دلخواه"
              )}
              defaultValue={columnTitle}
              component={Text}
              // defaultValue={defaultValue}
              required={1}
            />
          </Col>
        );
        break;
      case "DATEPICKER":
      case "DATE":
        _item = (
          <Col sm={24} md={24}>
            <Field
              name={`valueType`}
              label={app.translate(`components.form-builder.تاریخ`, "تاریخ")}
              component={Date}
              defaultValue={columnTitle}
              required={1}
            />
          </Col>
          // _item = (
          //   <Col sm={24} md={md} key={_key} style={{ display: visibility }}>
          //     <Field
          //       name={`values[${name}]`}
          //       // min={
          //       //   item.name === "base_date"
          //       //     ? jMoment().format("YYYY-MM-DD")
          //       //     : undefined
          //       // }
          //       label={app.translate(
          //         `components.form-builder.${item.label}`,
          //         `${item.label}`
          //       )}
          //       required={item.required == 1 ? true : false}
          //       defaultValue={rowClick ? fromDate : defaultValue}
          //       props={{
          //         type: rowClick,
          //       }}
          //       component={Date}
          //     />
          //   </Col>
          // );
        );
        break;
      case "TIMEPICKER":
      case "TIME":
        _item = (
          <Col sm={24} md={24} style={{ display: visibility }}>
            <Field
              name={`valueType`}
              label={app.translate(`components.form-builder.زمان`, "زمان")}
              component={Time}
              defaultValue={columnTitle ? columnTitle : "00:00"}
              required={1}
            />
          </Col>
        );
        break;

      case "TEXT":
        _item = (
          <Col sm={24} md={24}>
            <Field
              name={`valueType`}
              label={app.translate(
                `components.form-builder.متن دلخواه`,
                "متن دلخواه"
              )}
              defaultValue={columnTitle}
              component={Text}
              // defaultValue={defaultValue}
              required={1}
            />
          </Col>
        );
        break;

      case "INT":
        _item = (
          <Col sm={24} md={24}>
            <Field
              name={`valueType`}
              label={app.translate(
                `components.form-builder.عدد دلخواه `,
                "عدد دلخواه "
              )}
              component={Number}
              defaultValue={columnTitle}
              required={1}
            />
          </Col>
        );
        break;
      default: {
        let _name = item.name;
        switch (_name) {
          case "userFamiliesName":
            _item = (
              <Col sm={24} md={24} key={_key}>
                <Field
                  name={`valueType`}
                  label={app.translate(
                    `components.form-builder.${item.label}`,
                    item.label
                  )}
                  component={FamiliesName}
                  defaultValue={defaultValue}
                  positionId={this.props.values.positionId}
                />
              </Col>
            );
            break;
          default:
            _item = (
              <Col sm={24} key={_key}>
                <span>
                  {item.name} : {item.type}
                </span>
              </Col>
            );
        }
      }
    }
    return _item;
  }

  _itemValue(item, index, value,formValues) {
    
    const { md, visible, showHidden } = this.props;
    let _type = item.type.toUpperCase();
    //console.log(item, index, value)
    let _return = "";
    if (visible) {
      switch (_type) {
        case "DATEPICKER":
        case "DATE":
          _return = (
            <Col sm={24} md={md} key={index}>
              <span className="request-info-title">
                <MaterialIcon name="calendar" size="tiny" />
                {app.translate(
                  `components.form-builder.${item.label}`,
                  item.label
                )}{" "}
                :{" "}
              </span>
              {item.name=="my_shift_date"?jMoment(formValues.date, "YYYY-M-D").format("dddd jYYYY/jMM/jDD"):value &&jMoment(value, "YYYY-M-D").format("dddd jYYYY/jMM/jDD")}
            </Col>
          );
          break;
        case "TIMEPICKER":
        case "TIME":
          _return = (
            <Col sm={24} md={md} key={index}>
              <span className="request-info-title">
                <MaterialIcon name="clock" size="tiny" />
                {app.translate(
                  `components.form-builder.${item.label}`,
                  item.label
                )}{" "}
                :{" "}
              </span>
              {value}
            </Col>
          );
          break;
        case "NUMBER":
          _return = (
            <Col sm={24} md={md} key={index}>
              <span className="request-info-title">
                <MaterialIcon name="numeric" size="tiny" />
                {app.translate(
                  `components.form-builder.${item.label}`,
                  item.label
                )}{" "}
                :{" "}
              </span>
              {value}
            </Col>
          );
          break;
        case "TEXT":
          _return = (
            <Col sm={24} md={md} key={index}>
              fgfg
            </Col>
          );
          break;
        case "HIDDEN":
          break;
        case "SELECT":
          switch (item.resource) {
            case "Api\\General\\Models\\Shift":
              _return = (
                <Col sm={24} md={24} key={index}>
                  <span className="request-info-title">
                    <MaterialIcon name="note-outline" size="tiny" />
                    {app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}{" "}
                    :
                  </span>{value}
                </Col>
              );
              break;
            case "Api\\FeedingConsole\\Models\\Reserve":
              _return = (
                <Col sm={24} md={24} key={index}>
                  <span className="request-info-title">
                    <MaterialIcon name="note-outline" size="tiny" />
                    {app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}{" "}
                    :{" "}
                  </span>
                  <SelectReserveDateFoodMealInfo
                    reserveDateFoodMealId={value}
                  />
                </Col>
              );
              break;
            case "Api\\FeedingConsole\\Models\\DateFoodMeal":
              _return = (
                <Col sm={24} md={24} key={index}>
                  <span className="request-info-title">
                    <MaterialIcon name="note-outline" size="tiny" />
                    {app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}{" "}
                    :{" "}
                  </span>
                  {value}
                </Col>
              );
              break;

            case "Api\\FeedingConsole\\Models\\Meal":
              _return = (
                <Col sm={24} md={24} key={index}>
                  <span className="request-info-title">
                    <MaterialIcon name="note-outline" size="tiny" />
                    {app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}{" "}
                    :{" "}
                  </span>
                  <SelectFoodMealInfo foodMealId={value} />
                </Col>
              );
              break;

            case "Api\\FeedingConsole\\Models\\SelfModel":
              _return = (
                <Col sm={24} md={24} key={index}>
                  <span className="request-info-title">
                    <MaterialIcon name="note-outline" size="tiny" />
                    {app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}{" "}
                    :{" "}
                  </span>
                  <SelectSelfServiceInfo selfServiceId={value} />
                </Col>
              );
              break;

            case "Api\\General\\Models\\Position":
              _return = (
                <Col sm={24} md={24} key={index}>
                  <span className="request-info-title">
                    <MaterialIcon name="note-outline" size="tiny" />
                    {app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}{" "}
                    :{" "}
                  </span>
                  <DepartmentListInfo positionId={value} />
                </Col>
              );
              break;

            case "Api\\Users\\Models\\Profile":
              _return = (
                <Col sm={24} md={24} key={index}>
                  <span className="request-info-title">
                    <MaterialIcon name="note-outline" size="tiny" />
                    {app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}{" "}
                    :{" "}
                  </span>
                  <SelectProfileInfo personnelId={value} />
                </Col>
              );
              break;

            case "Api\\Requests\\Models\\Request":
              _return = (
                <Col sm={24} md={md} key={index}>
                  <span className="request-info-title">
                    <MaterialIcon name="note-outline" size="tiny" />
                    {app.translate(
                      `components.form-builder.${item.label}`,
                      item.label
                    )}{" "}
                    :{" "}
                  </span>
                  ???
                </Col>
              );
              break;
            default: {
              if (item.name === "clocking_type") {
                _return = (
                  <Col sm={24} md={md} key={index}>
                    <span className="request-info-title">
                      <MaterialIcon name="note-outline" size="tiny" />
                      {app.translate(
                        `components.form-builder.${item.label}`,
                        item.label
                      )}{" "}
                      :{" "}
                    </span>

                    <span>
                      {app.translate(`components.form-builder.${value}`)}
                    </span>
                    <MaterialIcon
                      name={
                        value === "in"
                          ? "arrow-down-thick"
                          : value === "out"
                          ? "arrow-up-thick"
                          : "swap-vertical"
                      }
                      size="tiny"
                      style={{
                        color:
                          value === "in"
                            ? "green"
                            : value === "out"
                            ? "red"
                            : "orange",
                      }}
                    />
                  </Col>
                );
              } else {
                let _values = {};

                if (item.values && item.values !== "") {
                  if (typeof item.values === "object") {
                    _values = item.values ? item.values : {};
                  } else {
                    _values = item?.values ? JSON.parse(item?.values) : {};
                  }
                } else {
                  if (item.props && item.props !== "") {
                    if (typeof item.props === "object") {
                      _values = item.props ? item.props : {};
                    } else {
                      _values = item.props ? JSON.parse(item.props) : {};
                    }
                  }
                }

                _return = (
                  <Col sm={24} md={md} key={index}>
                    <span className="request-info-title">
                      <MaterialIcon name="note-outline" size="tiny" />
                      {app.translate(
                        `components.form-builder.${item.label}`,
                        item.label
                      )}{" "}
                      :{" "}
                    </span>
                    {_values[value] || "????"}
                  </Col>
                );
              }
            }
          }
          break;

        case "SelectWrit":
          _return = (
            <Col sm={12} md={8} key={uuidv1()}>
              <span className="request-info-title">
                <MaterialIcon name="numeric" size="tiny" />
                {app.translate(
                  `routes.form-builder.${item.label}`,
                  item.label
                )}{" "}
                :{" "}
              </span>
              <SelectWritInfo dailyWritId={value} />
            </Col>
          );
          break;

        case "userFamiliesNameList":
          _return = (
            <Col sm={12} md={8} key={uuidv1()}>
              <span className="request-info-title">
                <MaterialIcon name="format-list-checks" size="tiny" />
                {app.translate(
                  `routes.form-builder.${item.label}`,
                  item.label
                )}{" "}
                :{" "}
              </span>
              <FamiliesNameInfo
                value={value}
                positionId={
                  this.props.values && this.props.values.positionId
                    ? this.props.values.positionId
                    : 0
                }
              />
            </Col>
          );
          break;
        case "SelectPositions":
          break;
        case "SelectRequest":
          /*   _form = (<Col sm={24} key={uuidv1()}>
               <span
                 className="request-info-title">
                   {app.translate('components.form-builder.Select Request')} : </span> {value}

             </Col>); */
          break;
        case "CHECKBOX":
          _return = (
            <Col sm={24} md={md} key={index}>
              <span className="request-info-title">
                <MaterialIcon name="pharmacy" size="tiny" />
                {app.translate(
                  `components.form-builder.${item.label}`,
                  item.label
                )}{" "}
                :
              </span>
              <MaterialIcon
                name={value === "true" || value === true ? "check" : "close"}
                style={{
                  color: value === "true" || value === true ? "green" : "red",
                }}
                size="tiny"
              />
            </Col>
          );
          break;
        case "JSON":
          let _val = JSON.parse(value);
          let _elment = [];
          app._.map(_val, (val) => {
            _elment.push(
              <Row key={uuidv1()}>
                <Col sm={8} md={8} key={uuidv1()}>
                  <span className="request-info-title">
                    <MaterialIcon name="calendar" size="tiny" />
                    {app.translate(`components.form-builder.date`)} :{" "}
                  </span>
                  <span style={{ display: "inline-block" }}>{val.date}</span>
                </Col>
                <Col sm={8} md={8} key={uuidv1()}>
                  <span className="request-info-title">
                    <MaterialIcon name="clock" size="tiny" />
                    {app.translate(`components.form-builder.time_from`)} :{" "}
                  </span>
                  {val.time_from}
                </Col>
                <Col sm={8} md={8} key={uuidv1()}>
                  <span className="request-info-title">
                    <MaterialIcon name="clock" size="tiny" />
                    {app.translate(`components.form-builder.time_to`)} :{" "}
                  </span>
                  {val.time_to}
                </Col>
              </Row>
            );
          });
          _return = (
            <Col sm={24} md={md} key={index}>
              <span className="request-info-title">
                {app.translate(
                  `components.form-builder.${item.label}`,
                  item.label
                )}{" "}
                :
              </span>
              {_elment}
            </Col>
          );
          break;
        case "FILE":
          _return = (
            <Col sm={24} md={md} key={index}>
              <span className="request-info-title">
                <MaterialIcon name="note-outline" size="tiny" />
                {app.translate(
                  `components.form-builder.${item.label}`,
                  item.label
                )}
                :
              </span>
              {value && (
                <a href={`${value}`} target="_blank" download="download">
                  {app.translate(
                    `components.form-builder.${item.label}`,
                    item.label
                  )}
                </a>
              )}
            </Col>
          );

          break;
        default:
          _return = (
            <Col sm={24} key={index}>
              {item.type}:{item.name} - {item.name}
            </Col>
          );
      }
    }
    if (showHidden) {
      switch (_type) {
        case "HIDDEN":
          _return = (
            <Col sm={24} key={index}>
              <span className="request-info-title">
                {/*<MaterialIcon
              name="note" size="tiny"/>
              {app.translate(`components.form-builder.${item.label}`, item.label)} : */}
              </span>
              <div className="spacer" />
              {item.defaultValue}
            </Col>
          );
          break;
        default:
          _return = "";
      }
    }
    return _return;
  }

  dynamicSort = (property) => {
    let sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      let result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  };
  _sort = (fields = []) => {
    let _fields;

    if (fields) {
      _fields = fields.sort(this.dynamicSort("priority"));
    }

    return _fields;
  };

  /**
   *
   * @returns *
   */
  _formFieldsRender() {
    let _field = [];
    const { formValues, editable, valueType } = this.props;

    const { formFields } = this.state;
    console.log("dependent_daily_leave", formValues);

    if (valueType) {
      _field.push(this._valueTypeItem(valueType));
    } else if (
      formFields &&
      formFields.fields &&
      formFields.fields.length > 0
    ) {
      const _fields = this._sort(formFields.fields);

      _fields.map((item, index) => {
        let name = app._.camelCase(item.name);

        _field.push(
          editable
            ? this._renderItem(item, index)
            : this._itemValue(item, index, formValues && formValues[name],formValues)
        );
      });
    } else {
      _field.push(
        <div
          key={uuidv1()}
          style={{ textAlign: "center", color: "#999", fontSize: "11px" }}
        >
          {app.translate(`components.form-builder.not thing`)}
        </div>
      );
    }

    return _field;
  }

  /**
   *
   * @return {XML}
   */
  render() {
    return (
      <Row
        style={{
          fontSize: "14px",
          lineHeight: "25px",
        }}
      >
        {this._formFieldsRender()}
      </Row>
    );
  }
}
